export type {
    GetUserNotificationsQueryVariables,
    GetUserNotificationsQuery
} from './lib/queries/notifications/GetUserNotifications.generated';

export { GetUserNotificationsDocument } from './lib/queries/notifications/GetUserNotifications.generated';

export type {
    Notification,
    NotificationResult,
    QueryNotificationsArgs
} from './graphql.generated';

export {
    NotificationErrorCode,
    NotificationTypeValues
} from './graphql.generated';

export { filterNotifications } from './lib/helpers/helpers';

export { NotificationIcon } from './lib/components/NotificationIcon/NotificationIcon';
export { Notification as NotificationComponent } from './lib/components/Notification/Notification';
export { UpdateIndicator } from './lib/components/UpdateIndicator/UpdateIndicator';

export { useUnseenNotificationCount } from './lib/hooks/useUnseenNotificationCount';
export { getNotifications } from './lib/getNotifications';
export { useNotifications } from './lib/hooks/useNotifications';

export * from './lib/features';
